module.exports = __webpack_public_path__ + "static/flags/NT-6a10373df25091392ccf93c6a61e0ca3.gif";